import { Routes, Route } from "react-router-dom";
import Layout from "../components/Layout";
import { CreateAcademicLevel } from "../pages/AcademicLevels/CreateAcademicLevel";
import { UpdateAcademicLevel } from "../pages/AcademicLevels/UpdateAcademicLevel";
import { AcademicPeriods } from "../pages/AcademicPeriod/AcademicPeriods";
import { CreateAcademicPeriod } from "../pages/AcademicPeriod/CreateAcademicPeriod";
import { UpdateAcademicPeriod } from "../pages/AcademicPeriod/UpdateAcademicPeriod";
import { AcademicYears } from "../pages/AcademicYear/AcademicYears";
import { CreateAcademicYear } from "../pages/AcademicYear/CreateAcademicYear";
import ForgotPassword from "../pages/Account/ForgotPassword/ForgotPassword";
import Login from "../pages/Account/Login";
import NewPassword from "../pages/Account/NewPassword/NewPassword";
import { Assessments } from "../pages/Assessments/Assessments";
import { CreateAssessment } from "../pages/Assessments/CreateAssessment";
import { CreateGeneralAssessment } from "../pages/Assessments/CreateGeneralAssessment";
import { UpdateAssessment } from "../pages/Assessments/UpdateAssessment";
import { AssignTeacherClassesSubjects } from "../pages/Classes/AssignTeacherClassesSubjects";
import { BlockOrUnblockStudentGradePosting } from "../pages/Classes/BlockOrUnblockStudentGradePosting";
import { Classes } from "../pages/Classes/Classes";
import { CreateClass } from "../pages/Classes/CreateClass";
import { ManageClassStudents } from "../pages/Classes/ManageClassStudents";
import { ManageSchedule } from "../pages/Classes/ManageSchedule";
import { StudentSchoolSchedulePreview } from "../pages/Classes/StudentSchoolSchedulePreview";
import { TeacherSchoolSchedulePreview } from "../pages/Classes/TeacherSchoolSchedulePreview";
import { UpdateClass } from "../pages/Classes/UpdateClass";
import { Classrooms } from "../pages/Classroom/Classrooms";
import { CreateClassroom } from "../pages/Classroom/CreateClassroom";
import { UpdateClassroom } from "../pages/Classroom/UpdateClassroom";
import { ClassroomTypes } from "../pages/ClassroomTypes/ClassroomTypes";
import { CreateClassroomType } from "../pages/ClassroomTypes/CreateClassroomType";
import { UpdateClassroomTypes } from "../pages/ClassroomTypes/UpdateClassroomTypes";
import { CoursePlans } from "../pages/CoursePlan/CoursePlans";
import { CreateUpdateCoursePlan } from "../pages/CoursePlan/CreateUpdateCoursePlan";
import { Courses } from "../pages/Courses/Courses";
import CreateCourse from "../pages/Courses/CreateCourse";
import { CurriculumGrid } from "../pages/Courses/CurriculumGrid";
import UpdateCourse from "../pages/Courses/UpdateCourse";
import { AddSubjectPlan } from "../pages/CoursesSubjects/AddSubjectPlan";
import CreateCourseSubject from "../pages/CoursesSubjects/CreateCourseSubject";
import UpdateCourseSubject from "../pages/CoursesSubjects/UpdateCourseSubject";
import { CreateCta } from "../pages/Cta/CreateCta";
import { Ctas } from "../pages/Cta/Ctas";
import { UpdateCta } from "../pages/Cta/UpdateCta";
import Dashboard from "../pages/Dashboard";
import { CreateDepartament } from "../pages/Departaments/CreateDepartament";
import { Departaments } from "../pages/Departaments/Departaments";
import { UpdateDepartament } from "../pages/Departaments/UpdateDepartament";
import CreateEnrollmentRequiredDocument from "../pages/EnrollmentRequiredDocuments/CreateEnrollmentRequiredDocument";
import { EnrollmentRequiredDocuments } from "../pages/EnrollmentRequiredDocuments/EnrollmentRequiredDocuments";
import UpdateEnrollmentRequiredDocument from "../pages/EnrollmentRequiredDocuments/UpdateEnrollmentRequiredDocument";
import NotFound from "../pages/Errors/NotFound";
import Unauthorized from "../pages/Errors/Unauthorized";
import CreateFaculty from "../pages/Faculties/CreateFaculty";
import Faculties from "../pages/Faculties/Faculties";
import UpdateFaculty from "../pages/Faculties/UpdateFaculty";
import { CoursePayments } from "../pages/finance/CoursePayments/CoursePayments";
import { CreateCoursePayments } from "../pages/finance/CoursePayments/CreateCoursePayments";
import { UpdateCoursePayment } from "../pages/finance/CoursePayments/UpdateCoursePayment";
import { CreateLateFeeConfig } from "../pages/finance/LateFeeConfig/CreateLateFeeConfig";
import { LateFeeConfigs } from "../pages/finance/LateFeeConfig/LateFeeConfigs";
import { UpdateLateFeeConfig } from "../pages/finance/LateFeeConfig/UpdateLateFeeConfig";
import { CreatePaymentMethod } from "../pages/finance/PaymentMethods/CreatePaymentMethod";
import { PaymentMethods } from "../pages/finance/PaymentMethods/PaymentMethods";
import { UpdatePaymentMethod } from "../pages/finance/PaymentMethods/UpdatePaymentMethod";
import UploadPaymentFile from "../pages/finance/PaymentReference/UploadPaymentFile";
import { CreatePaymentType } from "../pages/finance/PaymentType/CreatePaymentType";
import { PaymentTypes } from "../pages/finance/PaymentType/PaymentTypes";
import { UpdatePaymentType } from "../pages/finance/PaymentType/UpdatePaymentType";
import { CreateProcessModel } from "../pages/finance/ProcessModels/CreateProcessModel";
import { UpdateProcessModel } from "../pages/finance/ProcessModels/UpdateProcessModel";
import FinanceReports from "../pages/finance/Reports/FinanceReports";
import { GetPaymentReferenceReport } from "../pages/finance/Reports/GetPaymentReferenceReport";
import { GetPaymentReferenceReportAdvanced } from "../pages/finance/Reports/GetPaymentReferenceReportAdvanced";
import { GetPaymentReport } from "../pages/finance/Reports/GetPaymentReport";
import { CreateEditSchoolBankConfig } from "../pages/finance/SchoolBankConfig/CreateEditSchoolBankConfig";
import SchoolBankConfig from "../pages/finance/SchoolBankConfig/SchoolBankConfig";
import { CreateStudentDebt } from "../pages/finance/StudentDebt/CreateStudentDebt";
import { GetStudentFinanceState } from "../pages/finance/StudentDebt/GetStudentFinanceState";
import { IrregularStudentDebts } from "../pages/finance/StudentDebt/IrregularStudentDebts";
import { MonthPayments } from "../pages/finance/StudentDebt/MonthPayments";
import { PayStudentDebt } from "../pages/finance/StudentDebt/PayStudentDebt";
import { CheckStudentDebtByStudent } from "../pages/finance/StudentDebt/StudentDebtByStudent";
import { StudentDebtPaymentTransactions } from "../pages/finance/StudentDebt/StudentDebtPaymentTransactions";
import { StudentDebts } from "../pages/finance/StudentDebt/StudentDebts";
import { UpdateStudentDebt } from "../pages/finance/StudentDebt/UpdateStudentDebt";
import { StudentDebtNotifications } from "../pages/finance/StudentDebtNotifications/StudentDebtNotifications";
import { CreateFormationArea } from "../pages/FormationAreas/CreateFormationArea";
import { FormationAreas } from "../pages/FormationAreas/FormationAreas";
import { UpdateFormationArea } from "../pages/FormationAreas/UpdateFormationArea";
import { CreateKnowledgeDomain } from "../pages/KnowledgeDomains/CreateKnowledgeDomain";
import { KnowledgeDomains } from "../pages/KnowledgeDomains/KnowledgeDomains";
import { UpdateKnowledgeDomain } from "../pages/KnowledgeDomains/UpdateKnowledgeDomain";
import { CreateKnowledgeSubDomain } from "../pages/KnowledgeSubDomains/CreateKnowledgeSubDomain";
import { KnowledgeSubDomains } from "../pages/KnowledgeSubDomains/KnowledgeSubDomains";
import { UpdateKnowledgeSubDomain } from "../pages/KnowledgeSubDomains/UpdateKnowledgeSubDomain";
import { Authors } from "../pages/Library/Authors/Authors";
import { CreateAuthor } from "../pages/Library/Authors/CreateAuthor";
import { UpdateAuthor } from "../pages/Library/Authors/UpdateAuthor";
import { Books } from "../pages/Library/Books/Books";
import { CreateBook } from "../pages/Library/Books/CreateBook";
import { ManageBookAuthors } from "../pages/Library/Books/ManageBookAuthors";
import { UpdateBook } from "../pages/Library/Books/UpdateBook";
import { Categories } from "../pages/Library/Categories/Categories";
import { CreateCategory } from "../pages/Library/Categories/CreateCategory";
import { UpdateCategory } from "../pages/Library/Categories/UpdateCategory";
import LibraryStats from "../pages/Library/LibraryStats";
import { CreateLoan } from "../pages/Library/Loans/CreateLoan";
import { Loans } from "../pages/Library/Loans/Loans";
import { CreateReservation } from "../pages/Library/Reservations/CreateReservation";
import { Reservations } from "../pages/Library/Reservations/Reservations";
import { UpdateReservation } from "../pages/Library/Reservations/UpdateReservation";
import { AssignManager } from "../pages/Manager/AssignManager";
import { CreateManager } from "../pages/Manager/CreateManager";
import { Managers } from "../pages/Manager/Managers";
import { SettingsPage } from "../pages/Manager/SettingsPage";
import { ThemeOptionsScreen } from "../pages/Manager/ThemeOptionsScreen";
import { UpdateManager } from "../pages/Manager/UpdateManager";
import { UploadModels } from "../pages/Manager/UploadModels";
import { AddSubjectPlanCourse } from "../pages/PlanSubjects/AddSubjectPlanCourse";
import CreateUpdatePlanSubjects from "../pages/PlanSubjects/CreateUpdatePlanSubjects";
import { PlanSubjects } from "../pages/PlanSubjects/PlanSubjects";
import { CreateScholarshipProvider } from "../pages/ScholarshipProviders/CreateScholarshipProvider";
import { ScholarshipProviders } from "../pages/ScholarshipProviders/ScholarshipProviders";
import { UpdateScholarshipProvider } from "../pages/ScholarshipProviders/UpdateScholarshipProvider";
import { CreateScholarShip } from "../pages/Scholarships/CreateScholarShip";
import { Scholarships } from "../pages/Scholarships/Scholarships";
import { UpdateScholarShip } from "../pages/Scholarships/UpdateScholarShip";
import { CreateScholarshipType } from "../pages/ScholarshipTypes/CreateScholarshipType";
import { ScholarshipTypes } from "../pages/ScholarshipTypes/ScholarshipTypes";
import { UpdateScholarshipType } from "../pages/ScholarshipTypes/UpdateScholarshipType";
import { CreateEntity } from "../pages/scientific/Entities/CreateEntity";
import { UpdateEntity } from "../pages/scientific/Entities/UpdateEntity";
import { CreateExhibitor } from "../pages/scientific/Exhibitors/CreateExhibitor";
import { Exhibitors } from "../pages/scientific/Exhibitors/Exhibitors";
import { AssignJudgesToProjectPhases } from "../pages/scientific/JudgePhaseProject/AssignJudgesToProjectPhases";
import { ProjectsAssignedToJudge } from "../pages/scientific/JudgePhaseProject/ProjectsAssignedToJudge";
import { ValidateProjectStep } from "../pages/scientific/JudgePhaseProject/ValidateProjectStep";
import { CreateJudge } from "../pages/scientific/Judges/CreateJudge";
import { CreatePhase } from "../pages/scientific/Phases/CreatePhase";
import { UpdatePhase } from "../pages/scientific/Phases/UpdatePhase";
import { CreateProject } from "../pages/scientific/Projects/CreateProject";
import { MyProjectsAsExhbitors } from "../pages/scientific/Projects/MyProjectsAsExhbitors";
import { UpdateProject } from "../pages/scientific/Projects/UpdateProject";
import { ViewProjectStep } from "../pages/scientific/Projects/ViewProjectStep";
import { CreateProjectType } from "../pages/scientific/ProjectTypes/CreateProjectType";
import { UpdateProjectType } from "../pages/scientific/ProjectTypes/UpdateProjectType";
import { CreateSubEntity } from "../pages/scientific/SubEntities/CreateSubEntity";
import { UpdateSubEntity } from "../pages/scientific/SubEntities/UpdateSubEntity";
import CreateScientificArea from "../pages/ScientificAreas/CreateScientificArea";
import { ScientificAreas } from "../pages/ScientificAreas/ScientificAreas";
import UpdateScientificArea from "../pages/ScientificAreas/UpdateScientificArea";
import { AssessmentsCalendar } from "../pages/Student/AssessmentsCalendar";
import { ClassLessonPlans } from "../pages/Student/ClassLessonPlans";
import { CreateEnrollment } from "../pages/Student/CreateEnrollment";
import { CreateStudentDocument } from "../pages/Student/CreateStudentDocument";
import { DuplicatedSchoolCodes } from "../pages/Student/DuplicatedCodes";
import { EmitStudentDocuments } from "../pages/Student/EmitStudentDocuments";
import { Enrollments } from "../pages/Student/Enrollments";
import { FindStudentGrades } from "../pages/Student/FindStudentGrades";
import { LessonPlanPreview } from "../pages/Student/LessonPlanPreview";
import { PrintEnrollmentDocs } from "../pages/Student/PrintEnrollmentDocs";
import { RenewEnrollment } from "../pages/Student/RenewEnrollment";
import { RenewMyEnrollment } from "../pages/Student/RenewMyEnrollment";
import { RequestStudentDocument } from "../pages/Student/RequestStudentDocument";
import { StudentCertificates } from "../pages/Student/StudentCertificates";
import { StudentDocuments } from "../pages/Student/StudentDocuments";
import { StudentGeneralGrades } from "../pages/Student/StudentGenerakGrades";
import { StudentGrades } from "../pages/Student/StudentGrades";
import { Students } from "../pages/Student/Students";
import { StudentsStatistics } from "../pages/Student/StudentsStatistics";
import { StudentSubscription } from "../pages/Student/StudentSubscription";
import { StudentTeacherEvaluation } from "../pages/Student/StudentTeacherEvaluation";
import { SyncStudentsEsuraCentral } from "../pages/Student/SyncStudentsEsuraCentral";
import { UpdateEnrollment } from "../pages/Student/UpdateEnrollment";
import { UploadStudentCertificate } from "../pages/Student/UploadStudentCertificate";
import { CreateStudentSituation } from "../pages/StudentSituation/CreateStudentSituation";
import { StudentSituations } from "../pages/StudentSituation/StudentSituations";
import { UpdateStudentSituation } from "../pages/StudentSituation/UpdateStudentSituation";
import { Subjects } from "../pages/Subject/Subjects";
import { UpdateSubject } from "../pages/Subject/UpdateSubject";
import { CreateMySubscription } from "../pages/Subscriptions/CreateMySubscription";
import { CreateSubscription } from "../pages/Subscriptions/CreateSubscription";
import { Subscriptions } from "../pages/Subscriptions/Subscriptions";
import { SubscriptionsStatistics } from "../pages/Subscriptions/SubscriptionsStatistics";
import { SubscriptionStatisticsByCourse } from "../pages/Subscriptions/SubscriptionStatisticsByCourse";
import { SubscriptionsValidation } from "../pages/Subscriptions/SubscriptionsValidation";
import { UpdateSubscription } from "../pages/Subscriptions/UpdateSubscription";
import { ViewSubscription } from "../pages/Subscriptions/ViewSubscription";
import { CreateTeacherEvaluationCriterias } from "../pages/TeacherEvaluationCriterias/CreateTeacherEvaluationCriterias";
import { TeacherEvaluationCriterias } from "../pages/TeacherEvaluationCriterias/TeacherEvaluationCriterias";
import { UpdateTeacherEvaluationCriteria } from "../pages/TeacherEvaluationCriterias/UpdateTeacherEvaluationCriteria";
import { CreateTeacherRequiredDocument } from "../pages/TeacherRequiredDocuments/CreateTeacherRequiredDocument";
import { TeacherRequiredDocuments } from "../pages/TeacherRequiredDocuments/TeacherRequiredDocuments";
import UpdateTeacherRequiredDocument from "../pages/TeacherRequiredDocuments/UpdateTeacherRequiredDocument";
import { AddStudentExamGrades } from "../pages/Teachers/AddStudentExamGrades";
import { AddStudentGrades } from "../pages/Teachers/AddStudentGrades";
import { AddStudentGradesV2 } from "../pages/Teachers/AddStudentGradesV2";
import { CreateTeacher } from "../pages/Teachers/CreateTeacher";
import { EvaluateTeacher } from "../pages/Teachers/EvaluateTeacher";
import { GeneralStudentGrades } from "../pages/Teachers/GeneralStudentGrades";
import { GetSubjectPlans } from "../pages/Teachers/GetSubjectPlans";
import { ManageLessonPlans } from "../pages/Teachers/ManageLessonPlans";
import { TeacherClasses } from "../pages/Teachers/TeacherClasses";
import { TeacherEvaluations } from "../pages/Teachers/TeacherEvaluations";
import { Teachers } from "../pages/Teachers/Teachers";
import { UpdateLessonPlan } from "../pages/Teachers/UpdateLessonPlan";
import { UpdateTeacher } from "../pages/Teachers/UpdateTeacher";
import { ViewStudentExamGrades } from "../pages/Teachers/ViewStudentExamGrades";
import { ViewStudentGrades } from "../pages/Teachers/ViewStudentGrades";
import CreateUniversity from "../pages/Universities/CreateUniversity";
import Universities from "../pages/Universities/Universities";
import UpdateUniversity from "../pages/Universities/UpdateUniversity";
import { AddClaimsToRole } from "../pages/Users/AddClaimsToRole/AddClaimsToRole";
import { UserRoleAndClaims } from "../pages/Users/AddUserRoleAndCLaims/UserRoleAndClaims";
import { ChangePassword } from "../pages/Users/ChangePassword/ChangePassword";
import { ChangePasswordPolicy } from "../pages/Users/ChangePasswordPolicy/ChangePasswordPolicy";
import { Create_Edit_Role } from "../pages/Users/Create_Edit_Role/Create_Edit_Role";
import { Create_Edit_User } from "../pages/Users/Create_Edit_User/Create_Edit_User";
import { EditMyUser } from "../pages/Users/Create_Edit_User/EditMyUser";
import Roles from "../pages/Users/Roles";
import Users from "../pages/Users/Users";
import { CreateVacancy } from "../pages/Vacancy/CreateVacancy";
import { UpdateVacancy } from "../pages/Vacancy/UpdateVacancy";
import { Vacancies } from "../pages/Vacancy/Vacancies";
import ProtectedRoute from "../ProtectedRoute";
import ProtectedRouteAuthenticated from "../ProtectedRouteAuthenticated";
import ProtectedRouteNotAuthenticated from "../ProtectedRouteNotAuthenticated";
import { PdfPreview } from "../reports/PdfPreview";
import { routes } from "../routes";
import BulkEnrollmentByExcelFile from "../services/school/student/BulkEnrollmentByExcelFile";
import { claims } from "./claims";
import { usePageTracking } from "./usePageTracking";
import { ProcessModels } from "../pages/finance/ProcessModels/ProcessModels";
import { AcademicLevels } from "../pages/AcademicLevels/AcademicLevels";
import { CreateSubject } from "../pages/Subject/CreateSubject";
import { Entities } from "../pages/scientific/Entities/Entities";
import { Judges } from "../pages/scientific/Judges/Judges";
import { Phases } from "../pages/scientific/Phases/Phases";
import { Projects } from "../pages/scientific/Projects/Projects";
import { ProjectTypes } from "../pages/scientific/ProjectTypes/ProjectTypes";
import { SubEntities } from "../pages/scientific/SubEntities/SubEntities";
import { Certificate } from "../pages/Student/Certificate";
import NavigationLogs from "../pages/logs";

const AppContent: React.FC = () => {
    usePageTracking();
    return (
        <Layout>
            <Routes>
                <Route path={routes.newPassword} element={<NewPassword />} />
                <Route path={routes.forgotPassword} element={<ForgotPassword />} />
                {/* <Route element={<ProtectedRouteNotAuthenticated />}>
                  </Route> */}
                  //#region Se [Autenticado] - [Dashboard]
                <Route element={<ProtectedRouteAuthenticated />}>
                    <Route path={routes._} element={<Login />} />
                    <Route path={routes.login} element={<Login />} />
                </Route>
                  //#endregion

                #region Se [Não Autenticado] - [Login]
                <Route element={<ProtectedRouteNotAuthenticated />}>
                    <Route path={routes.dashboard} element={<Dashboard />} />
                    <Route path={routes.unauthorized} element={<Unauthorized />} />
                    <Route path={routes.__} element={<NotFound />} />
                    <Route path={routes.navigationLogs} element={<NavigationLogs />} />

                    #region CoursePayments
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateCoursePayment]} />}>
                        <Route path={routes.createCoursePayment} element={<CreateCoursePayments />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateCoursePayment]} />}>
                        <Route path={routes.updateCoursePayment} element={<UpdateCoursePayment />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetCoursePayments]} />}>
                        <Route path={routes.coursePayments} element={<CoursePayments />} />
                    </Route>
                    #endregion

                    #region LateFeeConfigies
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateLateFeeConfig]} />}>
                        <Route path={routes.createlateFeeConfig} element={<CreateLateFeeConfig />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateLateFeeConfig]} />}>
                        <Route path={routes.updatelateFeeConfig} element={<UpdateLateFeeConfig />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetLateFeeConfigies]} />}>
                        <Route path={routes.lateFeeConfigs} element={<LateFeeConfigs />} />
                    </Route>
                    #endregion

                    #region PaymentMethods
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreatePaymentMethod]} />}>
                        <Route path={routes.createPaymentMethod} element={<CreatePaymentMethod />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdatePaymentMethod]} />}>
                        <Route path={routes.updatePaymentMethod} element={<UpdatePaymentMethod />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetPaymentMethods]} />}>
                        <Route path={routes.paymentMethods} element={<PaymentMethods />} />
                    </Route>
                    #endregion

                    #region PaymentReferences
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUploadPaymentFile]} />}>
                        <Route path={routes.uploadPaymentFile} element={<UploadPaymentFile />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdatePaymentReference]} />}>
                        <Route path={routes.checkStudentDebtByStudent} element={<CheckStudentDebtByStudent />} />
                    </Route>
                    #endregion

                    #region PaymentTransactions
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreatePaymentTransaction]} />}>
                        <Route path={routes.payStudentDebt} element={<PayStudentDebt />} />
                        <Route path={routes.checkPayments} element={<StudentDebtPaymentTransactions />} />
                    </Route>
                    #endregion

                    #region PaymentTypies
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreatePaymentType]} />}>
                        <Route path={routes.createPaymentType} element={<CreatePaymentType />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdatePaymentType]} />}>
                        <Route path={routes.updatePaymentType} element={<UpdatePaymentType />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetPaymentTypies]} />}>
                        <Route path={routes.paymentTypes} element={<PaymentTypes />} />
                    </Route>
                    #endregion

                    #region Reports
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetActiveDebts]} />}>
                        <Route path={routes.getFinanceReports} element={<FinanceReports />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetPaymentsReport]} />}>
                        <Route path={routes.getPaymentReport} element={<GetPaymentReport />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetPaymentReferenceStatus]} />}>
                        <Route path={routes.getPaymentReferenceStatus} element={<GetPaymentReferenceReport />} />
                        <Route path={routes.getPaymentReferenceReportAdvanced} element={<GetPaymentReferenceReportAdvanced />} />
                    </Route>
                    #endregion

                    #region ProcessModels
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateProcessModel]} />}>
                        <Route path={routes.createProcessModel} element={<CreateProcessModel />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateProcessModel]} />}>
                        <Route path={routes.updateProcessModel} element={<UpdateProcessModel />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetProcessModels]} />}>
                        <Route path={routes.processModels} element={<ProcessModels />} />
                    </Route>
                    #endregion

                    #region SchoolBankConfigs
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateSchoolBankConfig]} />}>
                        <Route path={routes.createSchoolBankConfig} element={<CreateEditSchoolBankConfig />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateSchoolBankConfig]} />}>
                        <Route path={routes.updateSchoolBankConfig} element={<CreateEditSchoolBankConfig />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetSchoolBankConfigs]} />}>
                        <Route path={routes.getSchoolBankConfig} element={<SchoolBankConfig />} />
                    </Route>
                    #endregion

                    #region StudentDebties
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateStudentDebt]} />}>
                        <Route path={routes.createStudentDebt} element={<CreateStudentDebt />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateStudentDebt]} />}>
                        <Route path={routes.updateStudentDebt} element={<UpdateStudentDebt />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetStudentDebties]} />}>
                        <Route path={routes.studentDebts} element={<StudentDebts />} />
                        <Route path={routes.irregularStudentDebts} element={<IrregularStudentDebts />} />
                        <Route path={routes.monthPayments} element={<MonthPayments />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetStudentDebties_Student]} />}>
                        <Route path={routes.getStudentFinanceState} element={<GetStudentFinanceState />} />
                    </Route>
                    #endregion

                    #region StudentDebtNotifications
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateStudentDebtNotification]} />}>
                        <Route path={routes.getStudentFinanceNotifications} element={<StudentDebtNotifications />} />
                    </Route>
                    #endregion

                    #region AcademicLevels
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateAcademicLevel]} />}>
                        <Route path={routes.createAcademicLevel} element={<CreateAcademicLevel />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateAcademicLevel]} />}>
                        <Route path={routes.updateAcademicLevel} element={<UpdateAcademicLevel />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetAcademicLevels]} />}>
                        <Route path={routes.academicLevels} element={<AcademicLevels />} />
                    </Route>
                    #endregion

                    #region AcademicPeriods
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateAcademicPeriod]} />}>
                        <Route path={routes.createAcademicPeriod} element={<CreateAcademicPeriod />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateAcademicPeriod]} />}>
                        <Route path={routes.updateAcademicPeriod} element={<UpdateAcademicPeriod />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetAcademicPeriods]} />}>
                        <Route path={routes.academicPeriods} element={<AcademicPeriods />} />
                    </Route>
                    #endregion

                    #region AcademicYears
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetAcademicYears]} />}>
                        <Route path={routes.academicYears} element={<AcademicYears />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateAcademicYear]} />}>
                        <Route path={routes.createAcademicYear} element={<CreateAcademicYear />} />
                    </Route>
                    #endregion

                    #region Assessments
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateAssessment]} />}>
                        <Route path={routes.createAssessments} element={<CreateAssessment />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateGeneralAssessment]} />}>
                        <Route path={routes.createGeneralAssessments} element={<CreateGeneralAssessment />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateAssessment]} />}>
                        <Route path={routes.updateAssessments} element={<UpdateAssessment />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetAssessments_Teacher]} />}>
                        <Route path={routes.assessments} element={<Assessments />} />
                        <Route path={routes.generalStudentGrades} element={<GeneralStudentGrades />} />
                        <Route path={routes.viewStudentGrades} element={<ViewStudentGrades />} />
                        <Route path={routes.viewStudentExamGrades} element={<ViewStudentExamGrades />} />
                    </Route>
                    #endregion

                    #region Authors
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateAuthor]} />}>
                        <Route path={routes.createAuthor} element={<CreateAuthor />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateAuthor]} />}>
                        <Route path={routes.updateAuthor} element={<UpdateAuthor />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetAuthors]} />}>
                        <Route path={routes.authors} element={<Authors />} />
                    </Route>
                    #endregion

                    #region BookAuthors
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateBookAuthor]} />}>
                        <Route path={routes.manageBookAuthors} element={<ManageBookAuthors />} />
                    </Route>
                    #endregion

                    #region Books
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateBook]} />}>
                        <Route path={routes.createBook} element={<CreateBook />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateBook]} />}>
                        <Route path={routes.updateBook} element={<UpdateBook />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetBooks]} />}>
                        <Route path={routes.books} element={<Books />} />
                    </Route>
                    #endregion

                    #region Categories
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateCategory]} />}>
                        <Route path={routes.createCategory} element={<CreateCategory />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateCategory]} />}>
                        <Route path={routes.updateCategory} element={<UpdateCategory />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetCategories]} />}>
                        <Route path={routes.categories} element={<Categories />} />
                    </Route>
                    #endregion

                    #region Classes
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateClass]} />}>
                        <Route path={routes.createClass} element={<CreateClass />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateClass]} />}>
                        <Route path={routes.updateClass} element={<UpdateClass />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetClasses]} />}>
                        <Route path={routes.classes} element={<Classes />} />
                        <Route path={routes.blockOrUnblockStudentGradePosting} element={<BlockOrUnblockStudentGradePosting />} />
                    </Route>
                    #endregion

                    #region Classrooms
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateClassroom]} />}>
                        <Route path={routes.createClassroom} element={<CreateClassroom />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateClassroom]} />}>
                        <Route path={routes.updateClassroom} element={<UpdateClassroom />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetClassrooms]} />}>
                        <Route path={routes.classrooms} element={<Classrooms />} />
                    </Route>
                    #endregion

                    #region ClassroomTypes
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateClassroomType]} />}>
                        <Route path={routes.createClassroomType} element={<CreateClassroomType />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateClassroomType]} />}>
                        <Route path={routes.updateClassroomType} element={<UpdateClassroomTypes />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetClassroomTypes]} />}>
                        <Route path={routes.classroomTypes} element={<ClassroomTypes />} />
                    </Route>
                    #endregion

                    #region ClassSubjectTeachers
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateClassSubjectTeacher, claims.CanUpdateClassSubjectTeacher, claims.CanGetClassSubjectTeachers]} />}>
                        <Route path={routes.assignTeacherClassesSubjects} element={<AssignTeacherClassesSubjects />} />
                    </Route>
                    #endregion

                    #region CoursePlan
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateCoursePlan]} />}>
                        <Route path={routes.createCoursePlan} element={<CreateUpdateCoursePlan />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateCoursePlan]} />}>
                        <Route path={routes.updateCoursePlan} element={<CreateUpdateCoursePlan />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetCoursePlan]} />}>
                        <Route path={routes.coursePlans} element={<CoursePlans />} />
                    </Route>
                    #endregion

                    #region Courses
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateCourse]} />}>
                        <Route path={routes.createCourse} element={<CreateCourse />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateCourse]} />}>
                        <Route path={routes.updateCourse} element={<UpdateCourse />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetCourses]} />}>
                        <Route path={routes.courses} element={<Courses />} />
                    </Route>
                    #endregion

                    #region CoursesSubjects
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateCoursesSubject]} />}>
                        <Route path={routes.createCourseSubject} element={<CreateCourseSubject />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateCoursesSubject]} />}>
                        <Route path={routes.updateCourseSubject} element={<UpdateCourseSubject />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetCoursesSubjects]} />}>
                        {/* <Route path={routes.coursesSubjects} element={<CoursesSubjects />} />
                      <Route path={routes.courseSubjectV2} element={<CourseSubjectV2 />} /> */}
                        <Route path={routes.curriculumGrid} element={<CurriculumGrid />} />
                    </Route>
                    #endregion

                    #region Departments
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateDepartment]} />}>
                        <Route path={routes.createDepartament} element={<CreateDepartament />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateDepartment]} />}>
                        <Route path={routes.updateDepartament} element={<UpdateDepartament />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetDepartments]} />}>
                        <Route path={routes.departaments} element={<Departaments />} />
                    </Route>
                    #endregion

                    #region Enrollments
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateEnrollment]} />}>
                        <Route path={routes.createEnrollment} element={<CreateEnrollment />} />
                        <Route path={routes.bulkEnrollmentByExcelFile} element={<BulkEnrollmentByExcelFile />} />
                        <Route path={routes.renewEnrollment} element={<RenewEnrollment />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateEnrollment]} />}>
                        <Route path={routes.updateEnrollment} element={<UpdateEnrollment />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetEnrollments]} />}>
                        <Route path={routes.enrollments} element={<Enrollments />} />
                        <Route path={routes.duplicatedSchoolCodes} element={<DuplicatedSchoolCodes />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetStudentStatisticsEnrollments]} />}>
                        <Route path={routes.studentStatistics} element={<StudentsStatistics />} />
                    </Route>
                    #endregion

                    #region EnrollmentRequiredDocuments
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateEnrollmentRequiredDocument]} />}>
                        <Route path={routes.createEnrollmentRequiredDocument} element={<CreateEnrollmentRequiredDocument />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateEnrollmentRequiredDocument]} />}>
                        <Route path={routes.updateEnrollmentRequiredDocument} element={<UpdateEnrollmentRequiredDocument />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetEnrollmentRequiredDocuments]} />}>
                        <Route path={routes.enrollmentrequireddocuments} element={<EnrollmentRequiredDocuments />} />
                        <Route path={routes.printEnrollmentDocs} element={<PrintEnrollmentDocs />} />
                    </Route>
                    #endregion

                    #region Faculties
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateFaculty]} />}>
                        <Route path={routes.createFaculty} element={<CreateFaculty />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateFaculty]} />}>
                        <Route path={routes.updateFaculty} element={<UpdateFaculty />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetFaculties]} />}>
                        <Route path={routes.faculties} element={<Faculties />} />
                    </Route>
                    #endregion

                    #region FormationAreas
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateFormationArea]} />}>
                        <Route path={routes.createFormationArea} element={<CreateFormationArea />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateFormationArea]} />}>
                        <Route path={routes.updateFormationArea} element={<UpdateFormationArea />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetFormationAreas]} />}>
                        <Route path={routes.formationAreas} element={<FormationAreas />} />
                    </Route>
                    #endregion

                    #region KnowledgeDomains
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateKnowledgeDomain]} />}>
                        <Route path={routes.createKnowledgeDomain} element={<CreateKnowledgeDomain />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateKnowledgeDomain]} />}>
                        <Route path={routes.updateKnowledgeDomain} element={<UpdateKnowledgeDomain />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetKnowledgeDomains]} />}>
                        <Route path={routes.knowledgeDomains} element={<KnowledgeDomains />} />
                    </Route>
                    #endregion

                    #region KnowledgeSubDomains
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateKnowledgeSubDomain]} />}>
                        <Route path={routes.createKnowledgeSubDomain} element={<CreateKnowledgeSubDomain />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateKnowledgeSubDomain]} />}>
                        <Route path={routes.updateKnowledgeSubDomain} element={<UpdateKnowledgeSubDomain />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetKnowledgeSubDomains]} />}>
                        <Route path={routes.knowledgeSubDomains} element={<KnowledgeSubDomains />} />
                    </Route>
                    #endregion

                    #region LessonPlans
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateLessonPlan]} />}>
                        <Route path={routes.manageLessonPlans} element={<ManageLessonPlans />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateLessonPlan]} />}>
                        <Route path={routes.updateLessonPlan} element={<UpdateLessonPlan />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetLessonPlans]} />}>
                        <Route path={routes.getClassLessonPlans} element={<ClassLessonPlans />} />
                        <Route path={routes.previewLessonPlan} element={<LessonPlanPreview />} />
                    </Route>
                    #endregion

                    #region LibraryStats
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetLibraryStats]} />}>
                        <Route path={routes.libraryStats} element={<LibraryStats />} />
                    </Route>
                    #endregion

                    #region Loans
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateLoan]} />}>
                        <Route path={routes.createLoan} element={<CreateLoan />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetLoans]} />}>
                        <Route path={routes.loans} element={<Loans />} />
                    </Route>
                    #endregion

                    #region Managers
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateManager]} />}>
                        <Route path={routes.createManager} element={<CreateManager />} />
                        <Route path={routes.assignManager} element={<AssignManager />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateManager]} />}>
                        <Route path={routes.updateManager} element={<UpdateManager />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetManagers]} />}>
                        <Route path={routes.getManagers} element={<Managers />} />
                    </Route>
                    #endregion

                    #region PlanSubject
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreatePlanSubject]} />}>
                        <Route path={routes.createUpdatePlanSubjects} element={<CreateUpdatePlanSubjects />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetPlanSubject]} />}>
                        <Route path={routes.planSubjects} element={<PlanSubjects />} />
                    </Route>
                    #endregion

                    #region Reservations
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateReservation]} />}>
                        <Route path={routes.createReservation} element={<CreateReservation />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateReservation]} />}>
                        <Route path={routes.updateReservation} element={<UpdateReservation />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetReservations]} />}>
                        <Route path={routes.reservations} element={<Reservations />} />
                    </Route>
                    #endregion

                    #region RulesTeacherDocuments
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateRulesTeacherDocument]} />}>
                        <Route path={routes.createTeacherRequiredDocument} element={<CreateTeacherRequiredDocument />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateRulesTeacherDocument]} />}>
                        <Route path={routes.updateTeacherRequiredDocument} element={<UpdateTeacherRequiredDocument />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetRulesTeacherDocuments]} />}>
                        <Route path={routes.teacherRequiredDocuments} element={<TeacherRequiredDocuments />} />
                    </Route>
                    #endregion

                    #region ScholarshipProviders
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateScholarshipProvider]} />}>
                        <Route path={routes.createScholarshipProvider} element={<CreateScholarshipProvider />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateScholarshipProvider]} />}>
                        <Route path={routes.updateScholarshipProvider} element={<UpdateScholarshipProvider />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetScholarshipProviders]} />}>
                        <Route path={routes.scholarshipProviders} element={<ScholarshipProviders />} />
                    </Route>
                    #endregion

                    #region Scholarships
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateScholarship]} />}>
                        <Route path={routes.createScholarship} element={<CreateScholarShip />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateScholarship]} />}>
                        <Route path={routes.updateScholarship} element={<UpdateScholarShip />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetScholarships]} />}>
                        <Route path={routes.scholarships} element={<Scholarships />} />
                    </Route>
                    #endregion

                    #region ScholarshipTypes
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateScholarshipType]} />}>
                        <Route path={routes.createScholarshipType} element={<CreateScholarshipType />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateScholarshipType]} />}>
                        <Route path={routes.updateScholarshipType} element={<UpdateScholarshipType />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetScholarshipTypes]} />}>
                        <Route path={routes.scholarshipTypes} element={<ScholarshipTypes />} />
                    </Route>
                    #endregion

                    #region SchoolSchedules
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateSchoolSchedule, claims.CanUpdateSchoolSchedule, claims.CanGetSchoolSchedules]} />}>
                        <Route path={routes.manageSchedule} element={<ManageSchedule />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetSchoolSchedules]} />}>
                        <Route path={routes.teacherSchedule} element={<TeacherSchoolSchedulePreview />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetMySchoolSchedules]} />}>
                        <Route path={routes.studentSchedule} element={<StudentSchoolSchedulePreview />} />
                    </Route>
                    #endregion

                    #region ScientificAreas
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateScientificArea]} />}>
                        <Route path={routes.createScientificAreas} element={<CreateScientificArea />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateScientificArea]} />}>
                        <Route path={routes.updateScientificAreas} element={<UpdateScientificArea />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetScientificAreas]} />}>
                        <Route path={routes.scientificAreas} element={<ScientificAreas />} />
                    </Route>
                    #endregion

                    #region StudentAssessments
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetStudentAssessments]} />}>
                        <Route path={routes.findStudentGrades} element={<FindStudentGrades />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetMyStudentAssessments]} />}>
                        <Route path={routes.studentGrades} element={<StudentGrades />} />
                    </Route>
                    #endregion

                    #region StudentClasses
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetStudentClasses]} />}>
                        <Route path={routes.myAssessments} element={<AssessmentsCalendar />} />
                        <Route path={routes.teacherClasses} element={<TeacherClasses />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateStudentClass, claims.CanUpdateStudentClass, claims.CanGetStudentClasses]} />}>
                        <Route path={routes.manageClassStudents} element={<ManageClassStudents />} />
                    </Route>
                    #endregion

                    #region StudentDocuments
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateStudentDocument]} />}>
                        <Route path={routes.createStudentDocument} element={<CreateStudentDocument />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateStudentDocument_Student]} />}>
                        <Route path={routes.requestStudentDocument} element={<RequestStudentDocument />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetStudentDocuments_Student]} />}>
                        <Route path={routes.studentDocuments} element={<StudentDocuments />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateStudentDocument]} />}>
                        <Route path={routes.emitStudentDocuments} element={<EmitStudentDocuments />} />
                    </Route>
                    #endregion

                    #region Students
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetStudentsSubscribedSubjects]} />}>
                        <Route path={routes.students} element={<Students />} />
                    </Route>
                    #endregion

                    #region StudentSituations
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateStudentSituation]} />}>
                        <Route path={routes.createStudentSituation} element={<CreateStudentSituation />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateStudentSituation]} />}>
                        <Route path={routes.updateStudentSituation} element={<UpdateStudentSituation />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetStudentSituations]} />}>
                        <Route path={routes.studentSituations} element={<StudentSituations />} />
                    </Route>
                    #endregion

                    #region StudentSubjectGrade
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateStudentSubjectGrade]} />}>
                        <Route path={routes.addStudentGradesV2} element={<AddStudentGradesV2 />} />
                        <Route path={routes.addStudentGrades} element={<AddStudentGrades />} />
                        <Route path={routes.addStudentExamGrades} element={<AddStudentExamGrades />} />
                    </Route>
                    #endregion

                    #region SubjectPlans
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateSubjectPlan]} />}>
                        <Route path={routes.addSubjectPlan} element={<AddSubjectPlan />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateSubjectPlan]} />}>
                        <Route path={routes.addSubjectPlanCourse} element={<AddSubjectPlanCourse />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetSubjectPlans]} />}>
                        <Route path={routes.getSubjectPlans} element={<GetSubjectPlans />} />
                    </Route>
                    #endregion

                    #region Subjects
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateSubject]} />}>
                        <Route path={routes.createSubject} element={<CreateSubject />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateSubject]} />}>
                        <Route path={routes.updateSubject} element={<UpdateSubject />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetSubjects]} />}>
                        <Route path={routes.subjects} element={<Subjects />} />
                    </Route>
                    #endregion

                    #region Subscriptions
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateSubscription]} />}>
                        <Route path={routes.createSubscription} element={<CreateSubscription />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateMySubscription]} />}>
                        <Route path={routes.createMySubscription} element={<CreateMySubscription />} />
                        <Route path={routes.renewMyEnrollment} element={<RenewMyEnrollment />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateSubscription]} />}>
                        <Route path={routes.updateSubscription} element={<UpdateSubscription />} />
                        <Route path={routes.viewSubscription} element={<ViewSubscription />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetSubscriptions]} />}>
                        <Route path={routes.subscriptions} element={<Subscriptions />} />
                        <Route path={routes.subscriptionsValidation} element={<SubscriptionsValidation />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetSubscriptionStatistics]} />}>
                        <Route path={routes.subscriptionsStatistics} element={<SubscriptionsStatistics />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetSubscriptionStatisticsByCourse]} />}>
                        <Route path={routes.subscriptionsStatisticsCourse} element={<SubscriptionStatisticsByCourse />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetSubscriptionsByIDStudent]} />}>
                        <Route path={routes.studentSubscription} element={<StudentSubscription />} />
                    </Route>
                    #endregion

                    #region TeacherEvaluations
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateTeacherEvaluation]} />}>
                        <Route path={routes.studentTeacherEvaluation} element={<StudentTeacherEvaluation />} />
                        <Route path={routes.evaluateTeacher} element={<EvaluateTeacher />} />
                    </Route>

                    #endregion

                    #region TeacherEvaluationCriterias
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateTeacherEvaluationCriteria]} />}>
                        <Route path={routes.createTeacherEvaluationCriteria} element={<CreateTeacherEvaluationCriterias />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateTeacherEvaluationCriteria]} />}>
                        <Route path={routes.updateTeacherEvaluationCriteria} element={<UpdateTeacherEvaluationCriteria />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetTeacherEvaluationCriterias]} />}>
                        <Route path={routes.teacherEvaluationCriterias} element={<TeacherEvaluationCriterias />} />
                    </Route>
                    #endregion

                    #region TeacherEvaluationsCriterias
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetTeacherEvaluationsCriteriaReport]} />}>
                        <Route path={routes.teacherEvaluations} element={<TeacherEvaluations />} />
                    </Route>
                    #endregion

                    #region Teachers
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateTeacher]} />}>
                        <Route path={routes.createTeacher} element={<CreateTeacher />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateTeacher]} />}>
                        <Route path={routes.updateTeacher} element={<UpdateTeacher />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetTeachers]} />}>
                        <Route path={routes.teachers} element={<Teachers />} />
                    </Route>
                    #endregion

                    #region Universities
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateUniversity]} />}>
                        <Route path={routes.createUniversity} element={<CreateUniversity />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateUniversity]} />}>
                        <Route path={routes.updateUniversity} element={<UpdateUniversity />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetUniversities]} />}>
                        <Route path={routes.universities} element={<Universities />} />
                    </Route>
                    #endregion

                    #region Vacancies
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateVacancy]} />}>
                        <Route path={routes.createVacancy} element={<CreateVacancy />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateVacancy]} />}>
                        <Route path={routes.updateVacancy} element={<UpdateVacancy />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetVacancies]} />}>
                        <Route path={routes.vacancies} element={<Vacancies />} />
                    </Route>
                    #endregion

                    #region Ctas
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateCta]} />}>
                        <Route path={routes.createCta} element={<CreateCta />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateCta]} />}>
                        <Route path={routes.updateCta} element={<UpdateCta />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetCtas]} />}>
                        <Route path={routes.ctas} element={<Ctas />} />
                    </Route>
                    #endregion

                    #region Entities
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateEntity]} />}>
                        <Route path={routes.createEntity} element={<CreateEntity />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateEntity]} />}>
                        <Route path={routes.updateEntity} element={<UpdateEntity />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetEntities]} />}>
                        <Route path={routes.entities} element={<Entities />} />
                    </Route>
                    #endregion

                    #region Exhibitors
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateExhibitor]} />}>
                        <Route path={routes.createExhibitor} element={<CreateExhibitor />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetExhibitors]} />}>
                        <Route path={routes.exhibitors} element={<Exhibitors />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetJudgeAndExhibitorByUserId]} />}>
                        <Route path={routes.myProjectsAsExbitors} element={<MyProjectsAsExhbitors />} />
                        <Route path={routes.viewProjectSteps} element={<ViewProjectStep />} />
                    </Route>
                    #endregion

                    #region Judges
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateJudge]} />}>
                        <Route path={routes.createJudge} element={<CreateJudge />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetJudges]} />}>
                        <Route path={routes.judges} element={<Judges />} />
                    </Route>
                    #endregion

                    #region JudgesPhasesProjects
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetProjectsAssignedByIdJudge]} />}>
                        <Route path={routes.projectsAssignedToJudge} element={<ProjectsAssignedToJudge />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateJudgesPhasesProject]} />}>
                        <Route path={routes.createJudgePhaseProject} element={<AssignJudgesToProjectPhases />} />
                    </Route>
                    #endregion

                    #region JudgesPhasesProjectsDocuments
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateJudgesPhasesProjectsDocument]} />}>
                        <Route path={routes.validateProjectStep} element={<ValidateProjectStep />} />
                    </Route>
                    #endregion

                    #region Phases
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreatePhase]} />}>
                        <Route path={routes.createPhase} element={<CreatePhase />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdatePhase]} />}>
                        <Route path={routes.updatePhase} element={<UpdatePhase />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetPhases]} />}>
                        <Route path={routes.phases} element={<Phases />} />
                    </Route>
                    #endregion

                    #region Projects
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateProject]} />}>
                        <Route path={routes.createProject} element={<CreateProject />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateProject]} />}>
                        <Route path={routes.updateProject} element={<UpdateProject />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetProjects]} />}>
                        <Route path={routes.projects} element={<Projects />} />
                    </Route>
                    #endregion

                    #region ProjectTypes
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateProjectType]} />}>
                        <Route path={routes.createProjectType} element={<CreateProjectType />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateProjectType]} />}>
                        <Route path={routes.updateProjectType} element={<UpdateProjectType />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetProjectTypes]} />}>
                        <Route path={routes.projectTypes} element={<ProjectTypes />} />
                    </Route>
                    #endregion

                    #region SubEntities
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateSubEntity]} />}>
                        <Route path={routes.createSubEntity} element={<CreateSubEntity />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateSubEntity]} />}>
                        <Route path={routes.updateSubEntity} element={<UpdateSubEntity />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetSubEntities]} />}>
                        <Route path={routes.subEntities} element={<SubEntities />} />
                    </Route>
                    #endregion

                    #region Auth
                    {/* <Route element={<ProtectedRoute requiredClaims={[claims.CanChangePassword]} />}>
                      <Route path={routes.changePassword} element={<ChangePassword />} />
                    </Route> */}
                    {/* <Route element={<ProtectedRoute requiredClaims={[claims.CanNewPassword]} />}> */}
                    {/* </Route> */}
                    #endregion

                    #region PasswordPolicies
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdatePasswordPolicy]} />}>
                        <Route path={routes.changePasswordPolicy} element={<ChangePasswordPolicy />} />
                    </Route>
                    #endregion

                    #region Roles
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateRole]} />}>
                        <Route path={routes.createRole} element={<Create_Edit_Role />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateRole]} />}>
                        <Route path={routes.updateRole} element={<Create_Edit_Role />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetRoles]} />}>
                        <Route path={routes.roles} element={<Roles />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanAddClaimsToRole]} />}>
                        <Route path={routes.addClaimsToRole} element={<AddClaimsToRole />} />
                    </Route>
                    #endregion

                    #region Users
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanCreateUser]} />}>
                        <Route path={routes.createUser} element={<Create_Edit_User />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanUpdateUser]} />}>
                        <Route path={routes.updateUser} element={<Create_Edit_User />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanGetUsersWithPagination]} />}>
                        <Route path={routes.users} element={<Users />} />
                    </Route>
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanAddUserRole, claims.CanRemoveUserRole]} />}>
                        <Route path={routes.userRoleAndCLaims} element={<UserRoleAndClaims />} />
                    </Route>


                    #endregion

                    #region StudentSubjectGrade
                    <Route element={<ProtectedRoute requiredClaims={[claims.CanAddClaimsToRole]} />}>
                        <Route path={routes.addClaimsToRole} element={<AddClaimsToRole />} />
                    </Route>
                    #endregion
                    <Route element={<ProtectedRoute requiredClaims={[claims["CanGetStudents"]]} />}>
                        <Route path={routes.syncStudentsEsuraCentral} element={<SyncStudentsEsuraCentral />} />
                        <Route path={routes.studentGeneralGrades} element={<StudentGeneralGrades />} />
                    </Route>
                    <Route path={routes.pdfPreview} element={<PdfPreview />} />
                    <Route path={routes.uploadStudentCertificate} element={<UploadStudentCertificate />} />
                    <Route path={routes.certificates} element={<StudentCertificates />} />
                    <Route path={routes.editMyUser} element={<EditMyUser />} />
                    <Route path={routes.certificate} element={<Certificate />} />
                    <Route path={routes.changePassword} element={<ChangePassword />} />
                    <Route path={routes.settings} element={<SettingsPage />} />
                    <Route path={routes.Tema} element={<ThemeOptionsScreen />} />
                    <Route path={routes.UploadModels} element={<UploadModels type="CARTAO_ESTUDANTE" />} />
                </Route>
                #endregion
            </Routes>
        </Layout>
    );
};

export default AppContent;